import React from 'react';
import styled from '@emotion/styled';
import { Theme } from '@seedlang/constants';
import { isPresent } from '@seedlang/utils';

const IconWrapper = styled.div`
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: ${props => props.zIndex || Theme.z['card-4']};
  display: flex;
  flex-direction: row;
  align-items: center;
  .fa-check {
    color: ${Theme.green};
  }
  .fa-times {
    color: ${Theme.red};
  }
`;

const UserAnswerText = styled.span`
  color: ${Theme.red};
  font-size: 14px;
  margin-left: 12px;
  font-weight: bold;
`;

const CardAnswerIndicator = ({ correct, userAnswer, zIndex }) => {
  if (correct === undefined || correct === null) {
    return null;
  }

  return (
    <IconWrapper zIndex={zIndex}>
      {
        correct &&
        <i className='fa fa-check' />
      }
      {
        !correct &&
        <>
          <i className='fa fa-times' />
          {
            isPresent(userAnswer) &&
            <UserAnswerText>
              You answered "{userAnswer}"
            </UserAnswerText>
          }
        </>
      }
    </IconWrapper>
  );
};

export default CardAnswerIndicator;
